/* global client, checkoutId */

import Swiper from 'swiper';
import SwiperCore, { Navigation, Pagination, EffectFade, Thumbs } from 'swiper/core';
SwiperCore.use([Navigation, Pagination, EffectFade, Thumbs]);


/*/////////////////////////////////////////////
  Populate Single Product
*//////////////////////////////////////////////

window.populateProduct = function(rawProduct) {

  let product = [];
  let images = [];
  let variants = [];
  // console.log(rawProduct.title);

  product['title'] = rawProduct.title;
  product['id'] = rawProduct.id;
  product['handle'] = rawProduct.handle;
  product['image'] = rawProduct.images[0].src;
  product['price'] = rawProduct.variants[0].price;
  product['description'] = rawProduct.description;

  rawProduct.images.forEach(function (value, i){
    let newImage = {};
    newImage['url'] = value.src;

    images.push(newImage);
  })
  product['images'] = images;

  rawProduct.variants.forEach(function (value, i){
    let newVariant = {};
    newVariant['title'] = value.title;
    newVariant['id'] = value.id;
    newVariant['available'] = value.available;

    variants.push(newVariant);
  })
  product['variants'] = variants;

  window.dispatchEvent(new CustomEvent('fetchproduct', 
    {
      detail: {
        product: product,
      },
    }
  ));
}

export default {
  init() {

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    let handle = urlParams.get('productHandle');

    client.product.fetchByHandle(handle).then((product) => {
      // Do something with the product
      // console.log(product);
      window.populateProduct(product);
    }).finally(() => {
      const productSwiper = new Swiper('.product-slider', {
        slidesPerView: 1,
        watchOverflow: true,
        speed: 500,
        autoHeight: true,

        navigation: {
          nextEl: '.button-next',
          prevEl: '.button-prev',
          disabledClass: 'opacity-0 pointer-events-none',
        },

        pagination: {
          el: '.swiper-pagination',
        },
      });
    });

  },
};
